export const VIEWABLE   = 'viewable';
export const UNVIEWABLE = 'unviewable';


// WEBPACK FOOTER //
// ./src/Services/Measurement/ViewabilityStates.js